
import { mmToPx, pxToMm } from "@/utils/screen";
import Vue from "vue";
import { LayoutEditorEventBus } from "./layout-editor-event-bus";

export default Vue.extend({
	data() {
		return {
			dragging: false,
			offsetX: 0,
			offsetY: 0,
			startX: 0,
			startY: 0
		};
	},
	props: {
		x: Number,
		y: Number,
		disableX: Boolean,
		disableY: Boolean,
		useBottom: Boolean,
		minX: Number,
		minY: Number,
		maxX: Number,
		maxY: Number
	},
	computed: {
		xPx():number {
			return mmToPx(this.x);
		},
		yPx():number {
			return mmToPx(this.y);
		}
	},
	watch: {
		x(x: number) {
			if (this.maxX <= this.minX) return;
			if (this.minX != null) {
				if (x <= this.minX) {
					this.$emit("update:x", this.minX);
					return;
				}
			}
			if (this.maxX != null) {
				if (x > this.maxX) {
					this.$emit("update:x", this.maxX);
				}
			}
		},
		y(y: number) {
			if (this.maxY <= this.minY) return;
			if (this.minY != null) {
				if (y <= this.minY) {
					this.$emit("update:y", this.minY);
					return;
				}
			}
			if (this.maxY != null) {
				if (y > this.maxY) {
					this.$emit("update:y", this.maxY);
				}
			}
		},
		minX(){
			this.validate();
		},
		maxX(){
			this.validate();
		},
		minY(){
			this.validate();
		},
		maxY(){
			this.validate();
		}
	},
	methods: {
		mouseDown(event: MouseEvent) {
			if (event.button != 0) return;
			this.dragging = true;
			let el = this.$refs.root as HTMLDivElement;
			let parent = el.parentElement;
			if (!parent) return;
			this.offsetX = LayoutEditorEventBus.mouseX;
			this.offsetY = LayoutEditorEventBus.mouseY;
			this.startX = this.xPx;
			this.startY = this.yPx;
			LayoutEditorEventBus.dragging = true;
			this.$emit("mouse-down");
		},
		onMouseMove(data:{x:number, y:number}){
			if (!this.dragging) return;
			if (!this.disableY) {
				if (!this.useBottom) {
					var y = this.startY + data.y - this.offsetY;
				} else {
					var y = this.startY - data.y + this.offsetY;
				}
				this.$emit("update:y", pxToMm(y));
			}
			if (!this.disableX) {
				var x = this.startX + data.x - this.offsetX;
				this.$emit("update:x", pxToMm(x));
			}
		},
		onMouseUp(){
			this.dragging = false;
			LayoutEditorEventBus.dragging = false;
		},
		validate(){
			if (this.x > this.maxX || this.x < this.minX) {
				this.$emit("update:x", 0);
			}
			if (this.y > this.maxY || this.y < 0) {
				this.$emit("update:y", 0);
			}
		}
	},
	created() {
		LayoutEditorEventBus.$on("mouse-move", this.onMouseMove);
		LayoutEditorEventBus.$on("mouse-up", this.onMouseUp);
	},
	mounted(){
		this.validate();
	},
	destroyed(){
		LayoutEditorEventBus.$off("mouse-move", this.onMouseMove);
		LayoutEditorEventBus.$off("mouse-up", this.onMouseUp);
	}
});
